/* eslint-disable handle-callback-err */
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import router from '@/router.js'
import {
  storage
} from '@/utils/base'
import {
  baseURL
} from '@/utils/global.config'

// 创建实例
const instance = axios.create({
  baseURL: baseURL
})

// response错误处理
const responseError = error => {
  if (error.response) {
    switch (error.response.status) {
      case 401: // 无权限
        // 跳转登陆页面
        router.currentRoute.path !== 'login' &&
          router.replace({
            path: '/',
            query: {
              redirect: router.currentRoute.path // 将当前路由作为参数，登陆成功后又回到此页面
            }
          })
        break
      case 500: // 服务器错误
        notification.error({
          message: 'Forbidden',
          description: error.message
        })
        break
      default:
        break
    }
  } else {
    notification.error({
      message: 'Forbidden',
      description: error.message
    })
  }
  return Promise.reject(error)
}

// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    let auth = {
      Authorization: 'Bearer ' + storage.get('token')
    }
    config.headers = {
      ...auth
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(response => {
  if (response) {
    if (response.data.state && response.data.state !== 1) {
      notification.error({
        message: 'Forbidden',
        description: response.data.message
      })
    }
  }
  return response
}, responseError)

export default instance
